import { useBreakpointValue } from '@chakra-ui/react'
import React, { createContext, useContext } from 'react'

type BreakpointContextType = {
  isMobile: boolean
}

const BreakpointContext = createContext<BreakpointContextType | undefined>(
  undefined
)

export const BreakpointProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? false

  return (
    <BreakpointContext.Provider value={{ isMobile }}>
      {children ?? null}
    </BreakpointContext.Provider>
  )
}

export const useBreakpointContext = () => {
  const context = useContext(BreakpointContext)

  if (!context) {
    throw new Error(
      'useBreakpointContext must be used within a BreakpointProvider'
    )
  }

  return context
}
